import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import Auth from "./modules/auth.store"
import News from "./modules/news.store"
import Meeting from "./modules/meeting.store"
import Research from "./modules/research.store"
import User from "./modules/user.store"
import Budget from "./modules/budget.store"
import FormRF from "./modules/formRF.store"
import FormRL from "./modules/formRL.store"
import FormRO from "./modules/formRO.store"
import FormResearch from "./modules/formResearch.store";
import Common from "./modules/Common.store";


Vue.use(Vuex);

const modules = {
    Auth: Auth,
    News: News,
    Meeting: Meeting,
    Research: Research,
    User: User,
    Budget: Budget,
    FormRF: FormRF,
    FormResearch: FormResearch,
    Common: Common,
    FormRL: FormRL,
    FormRO: FormRO,
};

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState()]
})
